import AppBar from "@material-ui/core/esm/AppBar";
import useMediaQuery from "@material-ui/core/esm/useMediaQuery";
import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import NavigationDrawer from './Drawer/NavigationDrawer';
import NavigationNavbar from './NavBar/NavigationNavbar';
import useStyles from './NavigationStyles';
export default function Navigation() {
  const {
    navigationRoot
  } = useStyles();
  const theme = useTheme();
  const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));
  return /*#__PURE__*/React.createElement("div", {
    className: navigationRoot
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "static"
  }, isLargeDevice ? /*#__PURE__*/React.createElement(NavigationNavbar, null) : /*#__PURE__*/React.createElement(NavigationDrawer, null)));
}